<template>
  <div class="radar-card">
    <div class="card-glass-bg"></div>

    <div class="card-top">
      <span class="rank-badge">NO.{{ index + 1 }}</span>
      <span class="trend-tag" :class="item.hotness > 50 ? 'up' : 'stable'">
        {{ item.hotness > 50 ? '趋势上升' : '趋势平稳' }}
      </span>
    </div>

    <div class="gauge-wrapper">
      <svg viewBox="0 0 100 55" class="gauge-svg">
        <path d="M 10 50 A 40 40 0 0 1 90 50" fill="none" stroke="#f1f5f9" stroke-width="8" stroke-linecap="round" />
        <path
          d="M 10 50 A 40 40 0 0 1 90 50"
          fill="none"
          :stroke="workbench.getHeatColor(item.hotness)"
          stroke-width="8"
          stroke-linecap="round"
          :style="{
            strokeDasharray: 126,
            strokeDashoffset: 126 - (126 * item.hotness) / 100,
            filter: `drop-shadow(0 0 5px ${workbench.getHeatColor(item.hotness)})`
          }"
          class="gauge-path"
        />
        <circle cx="50" cy="50" r="3" fill="#1e293b" />
        <line
          x1="50"
          y1="50"
          x2="50"
          y2="15"
          stroke="#1e293b"
          stroke-width="2"
          stroke-linecap="round"
          :style="{ transform: `rotate(${(item.hotness / 100) * 180 - 90}deg)`, transformOrigin: '50px 50px' }"
          class="gauge-needle"
        />
      </svg>

      <div class="volume-display">
        <div class="v-num">{{ item.volume.toLocaleString() }}</div>
        <div class="v-label">AVG MONTHLY SEARCHES</div>
      </div>
    </div>

    <div class="card-bottom">
      <div class="kw-name" title="点击复制" @click="copy(item.keyword)">
        {{ item.keyword }}
        <svg class="copy-icon-micro" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke-width="2"></rect>
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke-width="2"></path>
        </svg>
      </div>
      <div class="kw-status" :style="{ color: workbench.getHeatColor(item.hotness) }">
        {{ workbench.getHeatStatus(item.hotness) }}
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { useClipboard } from '@/composables/useClipboard'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

defineProps({
  item: {
    type: Object,
    required: true
  },
  index: {
    type: Number,
    required: true
  }
})

const { copy } = useClipboard()
const workbench = useWorkbenchStore()
</script>
